import type { PerformancePart, ProfileGear, RiderMember } from '@tunasong/schemas'
import { riderRoleLabel } from './role-label.js'

/** What `GET /profiles/band-parts` tells generate and sync about one band */
export interface BandPartsInfo {
  /** userId → the parts they play in this band */
  parts: Record<string, PerformancePart[]>
  /** Members who said "I don't perform with {Band}" */
  notPerforming: string[]
}

/** A member has a stage setup when they listed an input with a source, or gear with a name */
export const hasStageSetup = (gear?: ProfileGear) =>
  Boolean(gear?.inputs?.some(input => input.source.trim()) || gear?.requirements?.some(item => item.name.trim()))

export type SetupSnapshot = Pick<
  RiderMember,
  'role' | 'requirements' | 'inputs' | 'parts' | 'monitorPreference' | 'engineerNotes' | 'setupUpdatedAt'
>

/** The part of a rider member row that comes from the member's setup. Absent optional values are left out. */
export const snapshotSetup = (gear: ProfileGear | undefined, parts: PerformancePart[] | undefined): SetupSnapshot => ({
  role: riderRoleLabel(parts, gear?.otherInstruments, gear?.role),
  requirements: gear?.requirements ?? [],
  ...(gear?.inputs ? { inputs: gear.inputs } : {}),
  ...(parts ? { parts } : {}),
  ...(gear?.monitorPreference ? { monitorPreference: gear.monitorPreference } : {}),
  ...(gear?.notes ? { engineerNotes: gear.notes } : {}),
  ...(gear?.updatedAt ? { setupUpdatedAt: gear.updatedAt } : {}),
})
